import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

import {GatewayTypeConfiguration, InstrumentGateway} from './InstrumentGatewayConstants';

export function instrumentGatewaysURL(): string {
  return `/instrument-gateways`;
}

export function getGateway(gatewayId: string): Promise<InstrumentGateway> {
  return net.getJSONPromise(`/1/api/instruments/gateways/${gatewayId}`);
}

interface ListGatewaysResponse {
  gateways: Array<InstrumentGateway>;
  nextToken?: string;
}

export function listGatewaysPage(nextToken?: string): Promise<ListGatewaysResponse> {
  const params = new URLSearchParams();
  if (nextToken) {
    params.set('nextToken', nextToken);
  }
  const query = params.toString();
  return net.getJSONPromise(`/1/api/instruments/gateways${query ? `?${query}` : ''}`);
}

export async function listGateways(): Promise<{gateways: Array<InstrumentGateway>}> {
  const allGateways: Array<InstrumentGateway> = [];
  let nextToken: string | undefined;
  do {
    const response = await listGatewaysPage(nextToken);
    allGateways.push(...response.gateways);
    nextToken = response.nextToken || undefined;
  } while (nextToken);
  return {gateways: allGateways};
}

export function listGatewayTypes(): Promise<{gatewayTypes: Array<GatewayTypeConfiguration>}> {
  return net.getJSONPromise('/1/api/instruments/gateway-types');
}

export function createGateway(
  gatewayName: string,
  gatewayType?: string,
  // TODO: Create gateway-specific types for fields when there is
  // more than one gateway type that needs fields passed in
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  fields?: any,
  generateToken?: boolean
): Promise<InstrumentGateway> {
  return net.postJSONPromise({
    url: `/1/api/instruments/gateways`,
    data: {name: gatewayName, gateway_type: gatewayType, fields, generate_token: generateToken},
  });
}

export function getGatewayInstaller(
  operatingSystem: string
): Promise<{downloadUrl: string; version: string; sha256Hash: string | null}> {
  return net.getJSONPromise(`/1/api/instruments/gateway-installer?operatingSystem=${operatingSystem}`);
}

export function getS3GatewayInstaller(): Promise<{roleArn: string}> {
  return net.getJSONPromise(`/1/api/instruments/gateway-installer`);
}

export function getCompatibilityScript(): Promise<{downloadUrl: string}> {
  return net.getJSONPromise(`/1/api/instruments/compatibility-script`);
}

export function createInstallerTokenFile(): Promise<{downloadUrl: string}> {
  return net.postJSONPromise({url: `/1/api/instruments/create-installer-token-file`});
}

interface BulkArchiveResponse {
  archivedItemIds: Array<string>;
}

export function updateGateway(
  gatewayId: string,
  name: string,
  fields?: Record<string, string>
): Promise<InstrumentGateway> {
  return net.postJSONPromise({
    url: `/1/api/instruments/gateways/${gatewayId}`,
    data: {name, fields},
  });
}

export function archiveGateway(gatewayId: string): Promise<BulkArchiveResponse> {
  return TaskRunner.postJSONPromise({url: `/1/api/instruments/gateways/${gatewayId}:archive`});
}
export function unarchiveGateway(gatewayId: string): Promise<{}> {
  return net.postJSONPromise({url: `/1/api/instruments/gateways/${gatewayId}:unarchive`});
}
